<template>
  <v-form id="companyDetails" class="companyDetailsForm" ref="form" lazy-validation>
    <h2 class="h2-details">Your Details</h2>
    <p>Please enter your details.</p>

    <v-text-field required solo dense
        name="company_name"
        :placeholder="$t('company_details.company_name.placeholder')"
        :rules="rules.company_name"
        v-model="company_name"
        maxlength="100"
        counter
    ></v-text-field>

    <v-textarea required solo dense name="company_description"
      :placeholder="$t('company_details.company_description.placeholder')"
      :rules="rules.company_description"
      :rows="6"
      auto-grow
      maxlength="400"
      counter
      v-model="company_description"
    ></v-textarea>

    <v-select solo dense
      name="industry"
      :label="$t('company_details.industry.label')"
      :items="industries"
      item-text="name"
      item-value="id"
      :rules="rules.industry"
      v-model="industry"
    ></v-select>
    <v-text-field required solo dense
        name="first_name"
        :placeholder="$t('company_details.first_name.placeholder')"
        :rules="rules.first_name"
        v-model="first_name"
        maxlength="25"
        counter
    ></v-text-field>
    <v-text-field required solo dense
        name="last_name"
        :placeholder="$t('company_details.last_name.placeholder')"
        :rules="rules.last_name"
        v-model="last_name"
        maxlength="25"
        counter
    ></v-text-field>
    <v-text-field required solo dense
        name="email"
        :placeholder="$t('company_details.email.placeholder')"
        :rules="rules.email"
        v-model="email"
        maxlength="50"
        counter
    ></v-text-field>
    <v-text-field required solo dense
        name="phone"
        :placeholder="$t('company_details.phone.placeholder')"
        :rules="rules.phone"
        v-model="phone"
    ></v-text-field>
    <!-- Start date picker -->
    <v-menu
      v-model="menu"
      name="v_menu_start_date"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          solo dense
          name="start_date"
          :placeholder="$t('company_details.start_date.placeholder')"
          :rules="rules.start_date"
          readonly
          v-on="on"
          v-model="start_date"
        ></v-text-field>
      </template>
      <v-date-picker v-model="start_date" @input="menu = false" no-title :max="maxAllowedDate" :min="minAllowedDate" locale="en-AU" ></v-date-picker>
    </v-menu>
    <v-text-field solo dense
        name="abn"
        :placeholder="$t('company_details.abn.placeholder')"
        :rules="rules.abn"
        v-model="abn"
        v-mask="'XX-XXX-XXX-XXX'"
    ></v-text-field>
    <v-row>
      <v-col>
        <v-btn @click="goBack">Go back</v-btn>
      </v-col>
      <v-col>
        <v-btn @click="validate" class="float-right">Continue</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  import {mapState} from "vuex";
  var moment = require('moment');

  export default {
    name: 'CompanyDetails',
    data: function() {
      return {
        maxAllowedDate: moment().add(60, 'days').format('YYYY-MM-DD'),
        minAllowedDate: moment().format('YYYY-MM-DD'),
        menu: false,
        rules: {
          company_name: [
              v => !!v || this.$t('company_details.company_name.required_text'),
            ],
          company_description: [
              v => !!v || this.$t('company_details.company_description.required'),
            ],
          industry: [
              v => !!v || this.$t('company_details.industry.required_text'),
            ],
          first_name: [
              v => !!v || this.$t('company_details.first_name.required_text'),
            ],
          last_name: [
              v => !!v || this.$t('company_details.last_name.required_text'),
            ],
          email: [
              v => !!v || this.$t('company_details.email.required_text'),
              v => /.+@.+/.test(v) || this.$t('company_details.email.email_invalid'),
            ],
          phone: [
              v => !!v || this.$t('company_details.phone.required_text'),
              () => this.valid_phone || this.$t('company_details.phone.invalid'),
            ],
          start_date: [
              v => !!v || this.$t('company_details.start_date.required_text'),
            ],
          abn: [
              v => (v == undefined || v === "") || v && this.validateABN(v) || this.$t('company_details.abn.invalid'),
            ],

        },
      }
    },
    computed: {
      ...mapState({
          industries: state => state.service_data.industries,
          valid_phone: state => state.company_details.phone_number_valid,
      }),
      company_name: {
        get() {
          return this.$store.state.company_details.company_name
        },
        set(value) {
          this.$store.commit('company_details/updateCompanyName', value)
        },
      },
      company_description: {
        get() {
          return this.$store.state.company_details.company_description;
        },
        set(value) {
          this.$store.commit('company_details/updateCompanyDescription', value)
        },
      },
      industry: {
        get() {
          return this.$store.state.company_details.industry;
        },
        set(value) {
          this.$store.commit('company_details/updateIndustry', value)
        },
      },
      first_name: {
        get() {
          return this.$store.state.company_details.first_name;
        },
        set(value) {
          this.$store.commit('company_details/updateFirstName', value)
        },
      },
      last_name: {
        get() {
          return this.$store.state.company_details.last_name;
        },
        set(value) {
          this.$store.commit('company_details/updateLastName', value)
        },
      },
      email: {
        get() {
          return this.$store.state.company_details.email;
        },
        set(value) {
          this.$store.commit('company_details/updateEmail', value)
        },
      },
      phone: {
        get() {
          return this.$store.state.company_details.phone;
        },
        set(value) {
          this.$store.commit('company_details/updatePhone', value)
          this.$store.dispatch('company_details/validatePhoneNumber');
        },
      },
      start_date: {
        get() {
          return this.$store.state.company_details.start_date;
        },
        set(value) {
          this.$store.commit('company_details/updateStartDate', value)
        },
      },
      abn: {
        get() {
          return this.$store.state.company_details.abn;
        },
        set(value) {
          this.$store.commit('company_details/updateAbn', value)
        },
      },
    },
    methods: {
      goBack() {
        this.$store.dispatch('service_data/goBack').then((next) => {
          this.$router.push(next);
        });
      },
      validateABN(abn_masked){
        const input = abn_masked.replace(/-/g, '');
        if (input.length != 11 || isNaN(parseInt(input))) return false
        let weighting = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19]
        let firstDigitProcessed = parseInt(input.charAt(0)) -1
        let weighted = firstDigitProcessed * weighting[0]

        for (var i = 1; i < input.length; i++) {
          weighted += (parseInt(input.charAt(i)) * weighting[i])
        }
        return (weighted % 89) == 0
      },
      validate() {
        this.$store.dispatch('service_data/stageSubmission', this.$refs.form).then( next => {
          // Push capture for signup campaign monitor.
            if(!this.$store.state.service_data.internalFlag) {
              // Only push if this isnt an internal route
              this.$store.dispatch('company_details/captureSignup');
            }
          this.$router.push(next);
        });
      },
    }
  }
</script>
<style scoped>
  form h2 {
    font-size: 29px;
    letter-spacing: -1px;
    font-weight: 400;
  }
  form p {
    margin-top: 20px;
    margin-bottom: 0;
  }
</style>
